import React from "react";
import uzair from "../images/team/uzair.png";
import usman from "../images/team/usman.png";
import mubashar from "../images/team/mubashar.png";
import danial from "../images/team/danial.png";
const Clients = () => {
  return (
    <div className="mt-8 bg-gray-100">
      <section class="py-12 px-4">
        <div class="text-center">
          <h2 class="text-yellow-500 font-semibold uppercase text-3xl font-bold">
            Our Team
          </h2>
          <p class="text-gray-500 mt-4 max-w-2xl mx-auto">
            Since 2018, our dedication has been assisting customers, ensuring
            they receive top-notch custom services tailored to empower them in
            advancing, expanding, and innovating within their industry.
          </p>
        </div>

        <div class="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div class="bg-white rounded-lg shadow-md p-6 text-center">
            <img
              src={uzair}
              alt="Muhammad Uzair"
              class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
            />
            <h3 class="text-lg font-semibold text-gray-900">MUHAMMAD UZAIR</h3>
            <p class="text-gray-500 text-sm">FOUNDER & CEO</p>
            <div class="text-yellow-500 text-3xl my-3">"</div>
          </div>

          <div class="bg-white rounded-lg shadow-md p-6 text-center">
            <img
              src="https://mir-s3-cdn-cf.behance.net/user/230/5ed5841316396035.677bd42ecc305.jpg"
              alt="Irzam Tariq"
              class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
            />
            <h3 class="text-lg font-semibold text-gray-900">IRZAM TAIRQ</h3>
            <p class="text-gray-500 text-sm">CTO / TECH LEAD</p>
            <div class="text-yellow-500 text-3xl my-3">"</div>
          </div>

          <div class="bg-white rounded-lg shadow-md p-6 text-center">
            <img
              src={mubashar}
              alt="Mubashar Bin Saeed"
              class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
            />
            <h3 class="text-lg font-semibold text-gray-900">
              MUBASHAR BIN SAEED
            </h3>
            <p class="text-gray-500 text-sm">VP OF PRODUCT</p>
            <div class="text-yellow-500 text-3xl my-3">"</div>
          </div>

          <div class="bg-white rounded-lg shadow-md p-6 text-center">
            <img
              src={usman}
              alt="Usman Khalil"
              class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
            />
            <h3 class="text-lg font-semibold text-gray-900">USMAN KHALIL</h3>
            <p class="text-gray-500 text-sm">LEAD FRONTEND DEVELOPER</p>
            <div class="text-yellow-500 text-3xl my-3">"</div>
          </div>

          <div class="bg-white rounded-lg shadow-md p-6 text-center">
            <img
              src="https://i.pinimg.com/736x/61/0d/df/610ddf8c725ed25c44096c37b4642188.jpg"
              alt="Mariyam Mushtaq"
              class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
            />
            <h3 class="text-lg font-semibold text-gray-900">MARIYAM MUSHTAQ</h3>
            <p class="text-gray-500 text-sm">DESIGN MANAGER</p>
            <div class="text-yellow-500 text-3xl my-3">"</div>
          </div>

          <div class="bg-white rounded-lg shadow-md p-6 text-center">
            <img
              src={danial}
              alt="Danial Sohail"
              class="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
            />
            <h3 class="text-lg font-semibold text-gray-900">DANIAL SOHAIL</h3>
            <p class="text-gray-500 text-sm">LEAD BACKEND DEVELOPER</p>
            <div class="text-yellow-500 text-3xl my-3">"</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;
